var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"arp-iframe",attrs:{"src":_vm.urlAcessoDocumento}})}
var staticRenderFns = []

export { render, staticRenderFns }